import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  className,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center text-lg font-semibold leading-5 border rounded px-10 py-[15px] transition-all duration-300 cursor-pointer font-inter whitespace-nowrap';
  const variants = {
    primary: 'bg-gold text-true-white border-black shadow-[4px_4px_0px_0px_#fff,4px_4px_0px_1px_#000] hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_#fff,6px_6px_0px_1px_#000]',
    outline: 'bg-transparent text-white border-white hover:bg-white hover:text-black hover:border-black shadow-[4px_4px_0px_0px_#046bd2,4px_4px_0px_1px_#000] hover:shadow-[4px_4px_0px_0px_#fff,4px_4px_0px_1px_#000]'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className || ''}`;
  return <button className={combinedClassName} {...props} data-id="element-245">
      {children}
    </button>;
}